import {
  byUserInteraction,
  cleanURL,
  csrfInit,
  exposeTourRadarMembershipExperiment,
  getCdnUrl,
  initializeAmplitudeSync,
  initializeGenericTopBanner,
  initializeLazyLoadedBackgroundImagesObserver,
  initializeSaleTopBanner,
  initiateAppBanner,
  initiateBodyScrollLock,
  initiateFallbackBackgroundImages,
  initLazyLoad,
  initParameters,
  initUserInteraction,
  initWindowAction,
  initializeSignupAndSavePopup,
  isDownloadBrochureModalOpened,
  loadAsyncCss,
  logBrokenImages,
  parameters,
  pwaInitiate,
  removeQueryStringParam,
  sendDataLayerEvent,
  sendGoogleEvent,
  exposeHeaderPaxSelectorExperiment,
} from './utils';

import {
  heartIconInitiate,
  navigationInitiate,
  profileWishllstInitiate,
  searchInitiate,
  topBannerInitiate,
  trustBannerInitiate,
  upsInitiate,
  headerPaxSelectorInitiate,
} from './header_script';

import {
  copyrightInitiate,
  siteExternalsInitiate,
  siteLinksInitiate,
  socialTracking,
} from './footer_script';
// eslint-disable-next-line import/prefer-default-export
initializeSaleTopBanner();
initiateFallbackBackgroundImages();
initLazyLoad();
initWindowAction();
initUserInteraction();
initParameters();
cleanURL();
csrfInit();
pwaInitiate();
initiateBodyScrollLock();
logBrokenImages();

if (document.readyState !== 'loading') {
  initializeLazyLoadedBackgroundImagesObserver();
} else {
  document.addEventListener('DOMContentLoaded', initializeLazyLoadedBackgroundImagesObserver);
}

if ($('header').length && parameters.page_type !== 'review') {
  navigationInitiate();

  // Check if ao-header-pax-selector exists, if so use headerPaxSelectorInitiate, otherwise use searchInitiate
  if ($('.ao-header-pax-selector').length) {
    headerPaxSelectorInitiate();
  } else {
    searchInitiate();
  }

  topBannerInitiate();
  trustBannerInitiate();
  upsInitiate();
  heartIconInitiate();
  profileWishllstInitiate();
}

if ($('footer').length && parameters.page_type !== 'review') {
  siteLinksInitiate();
  siteExternalsInitiate();
  copyrightInitiate();

  /* Language selector */
  $('.js-language-selector-title').on('click', () => {
    const $arrow = $('.js-language-selector-arrow');
    if (
      $arrow.length
      && ($arrow.width() || $arrow.height() || $arrow.css('display') !== 'none')
    ) {
      const $selector = $('.js-language-selector');
      if (
        $selector.width()
        || $selector.height()
        || $selector.css('display') !== 'none'
      ) {
        $arrow.addClass('bottom');
        $selector.css('display', 'none');
      } else {
        $('footer .rlk div').removeClass('open');
        $('footer .rlk div .arrow').addClass('bottom');
        $arrow.removeClass('bottom');
        $selector.css('display', 'block');
      }
    }
  });
  $('.js-language-selector').on('click', () => {
    $('.js-language-selector-list').toggleClass('hid');
    if (!$('.js-language-selector-list').hasClass('hid')) {
      $(document).on('click.language-selector', (event) => {
        const $target = $(event.target);
        if (
          !$target.hasClass('js-language-selector')
          && !$target.hasClass('js-language-selector-list')
        ) {
          $('.js-language-selector-list').toggleClass('hid');
          $(document).off('click.language-selector');
        }
      });
    } else {
      $(document).off('click.language-selector');
    }
  });
  $('.js-language-selector-list li').on('click', (event) => {
    const $link = $(event.target).find('a');
    if ($link.length) {
      document.location.href = $link.attr('href');
    }
  });

  /* Initiate Footer tracking */
  socialTracking();
}

if (window.location.search.length > 0) {
  const adTrackingName = removeQueryStringParam('_track_ad');

  if (!!adTrackingName && adTrackingName.length > 0) {
    sendDataLayerEvent({
      event: 'promotionClick',
      ecommerce: {
        promoClick: {
          promotions: [
            {
              id: adTrackingName,
              name: adTrackingName,
              position: 'serp-operator-id',
            },
          ],
        },
      },
    });

    sendGoogleEvent('Internal Promotions', 'click', adTrackingName);
  }
}

byUserInteraction('load-async-css', () => {
  loadAsyncCss(parameters.async_css);
});

if ($('.cn-body').length) {
  byUserInteraction('load-async-cookie-notification-css', () => {
    loadAsyncCss(`${getCdnUrl()}include/pw/cookie_notification/styles.css`);
  });
}

const downloadBrochureModalShouldOpen = isDownloadBrochureModalOpened();
if (downloadBrochureModalShouldOpen && parameters.async_css) {
  loadAsyncCss(parameters.async_css);
}

initializeGenericTopBanner();
initializeAmplitudeSync();
exposeTourRadarMembershipExperiment();
initiateAppBanner();
initializeSignupAndSavePopup();
exposeHeaderPaxSelectorExperiment();
